// src/features/simulators/online-checkin/components/OnlineCheckInSimulator.tsx

import React, { useState, useCallback } from 'react';
import { useTranslate } from 'react-admin';
import { Language as OnlineCheckInIcon } from '@mui/icons-material';
import { SimulatorWizard } from '../../shared/components/SimulatorWizard';
import { useSimulatorWizard } from '../../shared/hooks/useSimulatorWizard';
import { OnlineCheckInConfigForm } from './OnlineCheckInConfigForm';
import { useOnlineCheckInSimulation } from '../hooks/useOnlineCheckInSimulation';
import { LinkAccessMethod, ONLINE_CHECKIN_DEVICE_TYPE, ONLINE_CHECKIN_CHANNEL } from '../types';
import { KeyDeliveryMethod } from '../../shared/types/journey.types';
import type { OnlineCheckInConfigValues } from './OnlineCheckInConfigForm';

export const OnlineCheckInSimulator: React.FC = () => {
  const translate = useTranslate();
  const wizard = useSimulatorWizard({ deviceType: ONLINE_CHECKIN_DEVICE_TYPE, channel: ONLINE_CHECKIN_CHANNEL });
  const { simulate } = useOnlineCheckInSimulation();

  const [config, setConfig] = useState<OnlineCheckInConfigValues>({
    linkAccessMethod: LinkAccessMethod.EMAIL,
    keyDeliveryMethod: KeyDeliveryMethod.DIGITAL_MOBILE,
    reservationNumber: '',
    autoGenerateReservation: true,
  });

  const handleRun = useCallback(() => {
    wizard.runSimulation(async (client, addLog) => {
      return simulate(client, addLog, wizard.deviceId, wizard.hotelId, config);
    });
  }, [wizard, simulate, config]);

  return (
    <SimulatorWizard
      title={translate('resources.simulators.online_checkin.title')}
      subtitle={translate('resources.simulators.online_checkin.description')}
      icon={<OnlineCheckInIcon />}
      wizard={wizard}
      deviceType={ONLINE_CHECKIN_DEVICE_TYPE}
      channel={ONLINE_CHECKIN_CHANNEL}
      configForm={
        <OnlineCheckInConfigForm
          values={config}
          onChange={setConfig}
        />
      }
      onRun={handleRun}
    />
  );
};

export default OnlineCheckInSimulator;
